import { NgOptimizedImage } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CONSTANTS_DETAILS } from './../../model';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../../services/auth/auth.service';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  selector: 'app-header',
  imports: [
    MatMenuModule,
    TranslateModule,
    MatIconModule,
    NgOptimizedImage,
    MatFormFieldModule,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  public isLogoutMenuOpen: boolean = false;
  public authService = inject(AuthService);
  public userProfile = this.authService.getAccountGroups();
  public activeUserRoles = signal<string>('');
  public APP_NAME: string = CONSTANTS_DETAILS.APP_NAME;
  public translate = inject(TranslateService);

  constructor() {
    this.authService.userRoles.subscribe((roles) => {
      if (roles && roles.roles) {
        this.activeUserRoles.set(roles.roles.toString() || '');
      }
    });
  }

  /**
   * Logs out the user by calling the logoutUser method from AuthService.
   *
   * @memberof HeaderComponent
   */
  public logoutUser() {
    this.authService.logoutUser();
  }
}
